/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_CompletenessInputs */

const en_score_completeness = /** @type {(inputs: Score_CompletenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completeness`)
};

const de_score_completeness = /** @type {(inputs: Score_CompletenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständigkeit`)
};

/**
* | output |
* | --- |
* | "Completeness" |
*
* @param {Score_CompletenessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const score_completeness = /** @type {((inputs?: Score_CompletenessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_CompletenessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_score_completeness(inputs)
	return en_score_completeness(inputs)
});